import logobarralogin from "../../images/logobarralogin.png";
import datos from './../../data/configuracion'
const Footerlogin = () => {
  return (
    <footer
      className="w-[100vw] items-center flex flex-col justify-between 
bg-barralogin-200 text-white
 sm:flex-row sm:items-center
 md:flex-row md:items-center      
 lg:flex-row"
    >
      <div class="py-2 px-6 w-[15vw]">
        <img src={logobarralogin} alt="" />
      </div>
      <div>
        <ul
          className="h-[9vh] pb-5 text-[.9rem] flex flex-col gap-10  pr-5 items-center justify-center
           sm:flex-row sm:h-[9vh] sm:pb-1 md:flex-row md:h-[9vh] lg:flex-row lg:h-[9vh] 
            xl:flex-row xl:h-[9vh] xl:pb-1"  >
          <li className="text-linksligin-100">Versión {datos.version}</li>

          <li className="text-linksligin-100"><a
            target="_blank"
            rel="noopener noreferrer"
            href="https://sinestry.com/politica-sgi/">Política SGI</a></li>
          <li className="text-linksligin-100">
            <a className="text-linksligin-100"
              href="https://sinestry.com/aviso-de-privacidad/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aviso de Privacidad
            </a>
          </li>
          <li className="text-linksligin-100">
            <a className="text-linksligin-100"
              href="propiedadindustrial.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Propiedad Industrial: Uso Referencial
            </a>
          </li>
          <li className="text-linksligin-100">{datos.derechos}</li>
        </ul>
      </div>
    </footer>
  );
};
export default Footerlogin;
